 
import { Modal } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IAlertProps {
  title?: string | null;
  label: string;
  show: boolean;
  onHide: () => void;
  btnContinueText?: string;
  btnCancelText?: string;
  onConfirm?: () => void;
}

/**
 * Confirmation dialog
 */
const ConfirmDialog = ({ title, label, show, onHide, onConfirm, btnContinueText, btnCancelText }: IAlertProps) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [isText, setIsText] = useState<boolean>(false);
  const { t: translate } = useTranslation();

  useEffect(() => {
    if (!btnContinueText && !btnCancelText) {
      setIsText(false);
    } else { setIsText(true); }
  }, [btnContinueText, btnCancelText]);

  const handleConfirmDialog = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const handleCancelDailog = () => {
    setShowDialog(false);
    onHide();
  };

  useEffect(() => {
    setShowDialog(show);
  }, [show]);

  return (
    <Modal
      modalTitle={title ?? 'Cancel'}
      modalBody={label}
      modalShow={showDialog}
      btnCloseText={(isText ? btnCancelText : translate('confirm_dialog.lbl_close')) ?? ''}
      btnSaveText={(isText ? btnContinueText : translate('confirm_dialog.lbl_confirm')) ?? ''}
      onCloseModal={handleCancelDailog}
      onSaveModal={handleConfirmDialog}
      alignToCentre
      disableSaveBtn={false}
      disableCloseBtn={false}
      type="warning"
    />
  );
};
export default ConfirmDialog;
